module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/ko_3-ab40876e0eda4c9d5573c72714b04789.jpg";